import { render, staticRenderFns } from "./ReporteNovedadIncidente.vue?vue&type=template&id=fc21981e&scoped=true"
import script from "./ReporteNovedadIncidente.vue?vue&type=script&lang=js"
export * from "./ReporteNovedadIncidente.vue?vue&type=script&lang=js"
import style0 from "./ReporteNovedadIncidente.vue?vue&type=style&index=0&id=fc21981e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc21981e",
  null
  
)

export default component.exports